<template>
  <div>
    <TopBar @clear-filter="clearMedicalSpecialtyFilter(), this.$router.go(0)" />
    <section class="banner">
      <AppBreadcrumb :items="items" :background-color="'transparent'" />
      <div class="container banner__wrapper">
        <div class="banner__group-text">
          <h1 class="banner__title">Encontre um especialista</h1>
          <h3 class="banner__subtitle">
            Com excelentes profissionais, você pode continuar cuidando da sua
            saúde sem sair de casa.
          </h3>
          <!-- <form class="banner__form-inline">
            <input
              id="inlineFormInputName2"
              v-model="search"
              type="text"
              class="form-control mb-2 mr-sm-2"
              placeholder="Procure por uma especialidade"
            />
            <button
              type="submit"
              :disabled="isDisabled"
              :class="[isDisabled ? 'disabled' : '']"
              @click.prevent="findDoctors"
              @keyup.enter="findDoctors"
            >
              Buscar
            </button>
          </form>
          <div class="banner__specialties-group">
            <p>Busque por:</p>
            <p>
              <a href="#" class="banner__specialties-item">Cardiologia,</a>
            </p>
            <p>
              <a href="#" class="banner__specialties-item">Psicologia,</a>
            </p>
            <p>
              <a href="#" class="banner__specialties-item">Dermatologia,</a>
            </p>
            <p>
              <a href="#" class="banner__specialties-item">Pediatria.</a>
            </p>
          </div> -->
        </div>
        <div class="banner__group-image">
          <img src="./../assets/images/doctor-only.png" alt="" />
        </div>
      </div>
    </section>

    <!-- <section class="categories">
      <div class="container">
        <div class="categories__header">
          <h2 class="categories__header-title">Especialidades</h2>
          <h5 class="categories__header-more">
            <a href="#">Ver Mais</a>
          </h5>
        </div>
        <div class="categories__group">
          <a
            v-for="mostRequested in $store.state.speciality.mostRequested"
            href="#"
            :key="mostRequested.id"
            class="categories__card"
            @click.prevent="setMedicalSpecialties(mostRequested.id)"
          >
            <img
              :src="mostRequested.icon"
              alt="Cardiologistas"
              class="categories__image"
            />
            <h4 class="categories__card-title">{{ mostRequested.name }}</h4>
          </a>
        </div>
      </div>
    </section> -->

    <div class="container">
      <NavTabs
        :tabs="['Profissionais de saúde', 'Clínicas', 'Seja um parceiro']"
        :selected="selected"
        @selected="setSelectedTab"
      >
        <Tab :is-selected="selected === 'Profissionais de saúde'">
          <section class="doctors-cards">
            <div class="container">
              <div class="row">
                <div class="doctors-cards__header">
                  <!-- <div class="doctors-cards__filter">Filtro</div> -->
                </div>
                <div class="col-6">
                  <h3>&nbsp;</h3>
                </div>
                <div class="col-6 specialities-select">
                  <select
                    v-model="medical_specialty"
                    class="custom-select"
                    @change="setMedicalSpecialties(medical_specialty)"
                  >
                    <option :key="0" disabled :value="0">
                      Tipo(s) de especialidade
                    </option>
                    <option
                      v-for="speciality in $store.state.speciality.specialities"
                      :key="speciality.id"
                      :value="speciality.id"
                    >
                      {{ speciality.name }}
                    </option>
                  </select>
                  <Button
                    class="clear-filter-button ml-2"
                    @click.native="clearMedicalSpecialtyFilter"
                    variant="card"
                  >
                    Limpar filtro
                  </Button>
                </div>
                <div class="doctors-cards__group">
                  <div
                    v-for="doctor in doctors"
                    :key="doctor.id"
                    class="doctors-cards__item"
                  >
                    <div class="doctors-cards__item-infor">
                      <div class="doctors-cards__photo">
                        <a href="#">
                          <img
                            class="doctors-cards__photo-image"
                            :src="photoFallback(doctor.photo)"
                            alt="Imagem de perfil do profissional de saúde"
                          />
                        </a>
                        <!-- <div class="doctors-cards__rating">
                    <img
                      src="./../assets/images/star-icon.svg"
                      alt="Pontuação do profissional de saúde"
                    />
                    <span class="doctors-cards__number">4.8</span>
                    <span class="doctors-cards__number-comments">
                      (638 Avaliações)
                    </span>
                  </div> -->
                      </div>
                      <div class="doctors-cards__profile">
                        <div class="doctors-cards__top">
                          <h3
                            class="doctors-cards__name"
                            @click="doctorDetails(doctor)"
                          >
                            {{ doctor.name }}
                          </h3>
                          <div class="doctors-cards__infor-doctor">
                            <span class="doctors-cards__specialty">
                              {{
                                doctor.doctor_property.medical_specialty_name
                              }}
                            </span>
                            <span class="doctors-cards__crm">
                              {{ doctor.doctor_property.council_description }}
                            </span>
                          </div>
                        </div>
                        <div class="doctors-cards__middle">
                          <p class="doctors-cards__resume">
                            {{ doctor.short_bio }}
                          </p>
                        </div>
                        <div class="doctors-cards__bottom">
                          <span class="doctors-cards__value">
                            {{
                              convertToBrl(doctor.doctor_property.price_cents)
                            }}
                          </span>
                          <!-- <span class="doctors-cards__conditions">
                      (Em até 3x sem juros)
                    </span> -->
                        </div>
                      </div>
                    </div>
                    <TimeTable :doctor="doctor" />
                    <div v-if="hideNewSlotButton">
                      <AppButton
                        class="mt-5"
                        outline
                        :class="blockNewSlotButtonCss(doctor.id)"
                        @click.native="[sendSMStoDoctor(doctor.id), reloadPage()]"
                        :disabled="isNewSlotButtonDisabled(doctor.id)"
                      >
                        {{ changeNewSlotButtonLetters(doctor.id) }}
                      </AppButton>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </section>
        </Tab>

        <Tab :is-selected="selected === 'Clínicas'">
          <content-loader :is-loading="isLoadingInstitutions">
            <b-container>
              <institutions-list :institutions="institutions" />
            </b-container>
          </content-loader>
        </Tab>
      </NavTabs>
    </div>

    <FooterBase />
    <Copyright />
    <BModal
      id="loginOrRegistration"
      ref="loginOrRegistration"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Você precisa estar registrado para continuar, faça login ou crie uma
          conta
        </h4>
        <BButton class="button2 mb-2" block @click="loginOrCreate('Login')">
          Já possuo conta
        </BButton>

        <BButton class="button1" block @click="loginOrCreate('Register')">
          Criar uma conta
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script>
  import TimeTable from '../components/TimeTable';
  import TopBar from './../components/TopBar';
  import FooterBase from './../components/Footer';
  import Copyright from './../components/Copyright';
  import {
    specialityMethods,
    doctorMethods,
    councilMethods,
    userMethods,
  } from './../state/helpers';
  import { intToBRL } from './../utils/currency/convert';
  import AppBreadcrumb from '../components/AppBreadcrumb';
  import NavTabs from '../components/NavTabs';
  import Tab from '../components/Tab';
  import ContentLoader from '../components/ContentLoader.vue';
  import InstitutionsList from '../components/Institution/InstitutionList';
  import Button from '../components/Button.vue';
  import AppButton from '../components/AppButton';

  export default {
    name: 'Site',
    components: {
      TopBar,
      FooterBase,
      TimeTable,
      Copyright,
      AppBreadcrumb,
      NavTabs,
      Tab,
      ContentLoader,
      InstitutionsList,
      Button,
      AppButton,
    },

    data() {
      return {
        selected: 'Profissionais de saúde',
        institutions: [],
        search: '',
        medical_specialty: 0,
        isNewSlotRequested: false,
        querySmsToDoctor: '',
        newSlotButtonSelected: '',
        doctors: [],
        schedule_configuration_requests_reloaded: '',
        items: [
          {
            text: 'Home',
            link: '/',
          },
          {
            text: 'Especialistas por especialidades',
          },
        ],
      };
    },

    mounted() {
      this.getInstitutions();
      this.fetchAllSpecialities();
      this.fetchAllCouncils();

      if (this.loggedUser.id) {
        this.loadShowUser(this.$store.getters['user/getCurrentUser'].id);
      }

      if (this.$route.query.specialityId) {
        this.setMedicalSpecialties(this.$route.query.specialityId);
      } else {
        this.findDoctors();
      }

      if (this.$route.query.sms_to_doctor) {
        this.sendSMStoDoctor(this.$route.query.sms_to_doctor)
        setTimeout(() => {
          this.$router.push('/') && this.reloadPage()
        }, 1000);
      }

      this.fetchMostRequestedSpecialities();
      this.addSiteClassName();
    },

    methods: {
      ...specialityMethods,
      ...councilMethods,
      ...doctorMethods,
      ...userMethods,

      doctorDetails(doctor) {
        this.$router.push({
          name: 'DoctorDetails',
          params: { doctor: doctor.id },
        });
      },

      async getInstitutions() {
        const response = await this.$store.dispatch('institutions/fetchInstitutions');
        this.institutions = response.data;
      },

      async loadShowUser(user_id) {
        this.$store.dispatch('user/showUser', user_id)
            .then(response => {
              this.schedule_configuration_requests_reloaded =
              response.data.schedule_configuration_requests
            })
      },

      reloadPage() { this.loggedUser.id ? window.location.reload() : '' },

      blockNewSlotButtonCss(id) {
        let slot_solicitations = this.schedule_configuration_requests_reloaded

        return slot_solicitations.includes(id) ? 'block-new-slot-button' : ''
      },

      isNewSlotButtonDisabled(id) {
        if (this.loggedUser.id) {
          return this.schedule_configuration_requests_reloaded.includes(id)
            ? true : false
        } else {
          return false;
        }
      },

      sendSMStoDoctor(id) {
        this.querySmsToDoctor = id

        if (this.isLoggedIn) {
          this.$store.dispatch('doctor/sendSMStoDoctor', this.querySmsToDoctor)
              .then(response => response.data)
        } else {
          this.isNewSlotRequested = true
          this.$bvModal.show("loginOrRegistration");
        }
      },

      loginOrCreate(urlName) {
        this.$router.push({
          name: urlName, 
          query: this.isNewSlotRequested ?
            { redirectFrom: `/?sms_to_doctor=${this.querySmsToDoctor}` }
            : null
        });
      },

      findDoctors() {
        let paramters = {
          name: this.search,
          medical_specialty: this.medical_specialty,
        };
        this.fetchDoctors(paramters).then((response) => {
          response.data.filter((data) => {
            data.doctor_property.council_description = `${data.doctor_property.council_name} ${data.doctor_property.council_number} ${data.doctor_property.council_uf}`;
          });
          this.doctors = response.data;
        });
      },

      setMedicalSpecialties(specialtyId) {
        this.medical_specialty = specialtyId;
        this.findDoctors();
      },

      photoFallback(src) {
        return src || require('./../assets/images/doctor-fallback.png');
      },

      convertToBrl(price) { return intToBRL(price); },

      addSiteClassName() {
        const body = document.body;
        body.className = '';
        s;
        body.classList.add('Site');
      },

      setSelectedTab(tab) { this.selected = tab; },

      clearMedicalSpecialtyFilter() {
        this.medical_specialty = 0;
        this.findDoctors();
      },

      changeNewSlotButtonLetters(id) {
        let slot_solicitations = this.schedule_configuration_requests_reloaded

        return slot_solicitations.includes(id) ? 'Solicitação enviada' :
                                                 'Solicitar novos horários'
      },
    },

    computed: {
      hideNewSlotButton() {
        return this.$store.getters['user/userRole'] == 'patient' ||
               this.$store.getters['user/userRole'] == ''
      },

      isLoggedIn() { return this.$store.getters['auth/loggedIn'] },

      isDisabled() { return this.search.length <= 3 ? true : false; },

      isLoadingInstitutions() {
        return this.$store.getters['institutions/isLoading'];
      },

      loggedUser() { return this.$store.getters['auth/loggedUser'] }
    },
  };
</script>

<style scoped>
.new-slot-button {
  margin: 35px 0px 0px 0px;
}

.block-new-slot-button {
  background-color: gray;
  color: black;
  border: 1px solid black;
  opacity: 0.6;
}

.specialities-select {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
.clear-filter-button {
  height: 100%;
  color: #717171 !important;
}
.specialities-select select {
  border: none;
  border: solid 1px #dddddd;
  border-radius: 8px;
  height: 50px;
  color: #717171;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 255px;
}
.specialities-select select:hover {
  border-color: #222;
}
.specialities-select select:active {
  outline: 0;
}

@media (max-width: 1199px) {
  .specialities-select select {
    width: 255px;
    margin-left: -200px;
  }
}

/* BANNER FORM STYLE */
.banner__form-inline {
  margin-top: 16px;
  position: relative;
  display: flex;
}
@media (max-width: 768px) {
  .banner__form-inline {
    width: 100%;
    display: inline-block;
  }
}
.banner__form-inline::before {
  content: url('./../assets/images/search-icon.svg');
  position: absolute;
  left: 0;
  top: 18px;
  padding: 0 16px;
}
.banner__form-inline input {
  height: 56px;
  width: 488px;
  border: 0;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
  padding-left: 48px;
}
.banner__form-inline input::placeholder {
  color: rgba(113, 113, 113, 0.6);
}
.banner__form-inline input:focus {
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.2);
}
@media (max-width: 768px) {
  .banner__form-inline input {
    width: 100%;
    margin: 0 0 0.5em !important;
  }
}
.banner__form-inline button {
  font-size: 16px;
  font-weight: 600;
  height: 56px;
  color: #fff;
  background-color: #ed135a;
  border: 0;
  width: 157px;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.banner__form-inline button:hover {
  background-color: #ba0e46;
  color: #fff;
}
@media (max-width: 768px) {
  .banner__form-inline button {
    width: 100%;
  }
}
.banner__form-inline .disabled {
  background-color: rgba(128, 128, 128, 0.542);
}
.banner__form-inline .disabled:hover {
  background-color: rgba(128, 128, 128, 0.542);
}
.doctors-cards__photo img {
  object-fit: cover;
  object-position: center;
  -o-object-fit: cover;
  -o-object-position: center;
}
.Site {
  background-color: white;
}
.doctors-cards__photo-image {
  border: solid 1px #dee2e6;
}
.banner__wrapper {
  height: 360px !important;
}

@media (max-width: 992px) {
  .banner {
    padding: 0 !important;
  }
}
</style>
